// extracted by mini-css-extract-plugin
export var mainImage = "contactPage-module--mainImage--oOS0y";
export var form = "contactPage-module--form--ii0mV";